/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import EChartsReact from "echarts-for-react";
import moment from "moment";

// name: '视频广告',
// type: 'line',
// endLabel:{
//     show: true,
//     formatter:function(params){
//         return params.seriesName
//     }
// },
// data: [150, 232, 201, 154, 190, 330, 410]
export interface seriesProps {
  name: string;
  type: string;
  data: number[];
}

export interface StackedLineProps {
  timeQuantum?: number;
  legendData?: string[];
  seriesData?: seriesProps[];
  style?: React.CSSProperties;
}

export const StackedLine: React.FC<StackedLineProps> = ({
  legendData,
  seriesData,
  timeQuantum,
  style,
}) => {
  const [stackedLineOption, setstackedLineOption] = useState<any>();
  const [mouthData] = useState([
    "1月",
    "2月",
    "3月",
    "4月",
    "5月",
    "6月",
    "7月",
    "8月",
    "9月",
    "10月",
    "11月",
    "12月",
  ]);
  const [weekData] = useState([
    "周一",
    "周二",
    "周三",
    "周四",
    "周五",
    "周六",
    "周日",
  ]);
  const [xData, setXData] = useState<any>([]);

  useEffect(() => {
    if (timeQuantum === 2) {
      const startIndex = Number(moment().format("M"));
      setXData(
        mouthData.slice(startIndex).concat(mouthData.slice(0, startIndex))
      );
    } else if (timeQuantum === 1) {
      var arr = [];
      for (var i = 30; i > 0; i--) {
        const Days = Number(moment().subtract(i, "days").format("DD"));
        if (Days === 1) {
          arr.push(
            mouthData[Number(moment().subtract(i, "days").format("MM")) - 1]
          );
        } else {
          arr.push(Days);
        }
      }
      setXData(arr);
    } else if (timeQuantum === 0) {
      const startIndex = Number(moment().format("E"))-1;
      setXData(
        weekData.slice(startIndex).concat(weekData.slice(0, startIndex))
      );
    }
  }, [timeQuantum]);

  useEffect(() => {
    let option = {
      tooltip: {
        trigger: "axis",
      },
      legend: {
        data: legendData,
      },
      grid: {
        left: "3%",
        right: "4%",
        bottom: "3%",
        top: "12%",
        containLabel: true,
      },
      xAxis: {
        type: "category",
        boundaryGap: false,
        data: xData,
      },
      yAxis: {
        type: "value",
        axisLine: {
          show: true,
          symbol: ["none", "arrow"],
        },
      },
      series: seriesData,
    };
    setstackedLineOption(option);
  }, [legendData, seriesData, xData]);
  return (
    <>
      {stackedLineOption && (
        <EChartsReact
          option={stackedLineOption}
          notMerge={true}
          style={style}
        ></EChartsReact>
      )}
    </>
  );
};
